export const SUPPORTED_LOCALES = ['en', 'fr', 'fr-CA', 'es', 'pt', 'pt-BR'] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: 'English',
  fr: 'Français',
  'fr-CA': 'Français (Canada)',
  es: 'Español',
  pt: 'Português',
  'pt-BR': 'Português (Brasil)',
}

export const DEFAULT_LOCALE: SupportedLocale = 'en'

export const isSupportedLocale = (
  locale: string
): locale is SupportedLocale => {
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
}

/**
 * Case-insensitive locale normalization. Accept-Language headers and
 * navigator.languages may use different casing (e.g., "pt-br" vs "pt-BR").
 * Returns the canonical SupportedLocale or undefined if no match.
 */
const LOCALE_LOOKUP = new Map(
  SUPPORTED_LOCALES.map((l) => [l.toLowerCase(), l])
)

export const normalizeLocale = (raw: string): SupportedLocale | undefined => {
  // Try exact match first (fast path)
  if (isSupportedLocale(raw)) return raw
  // Case-insensitive match
  return LOCALE_LOOKUP.get(raw.toLowerCase())
}
